import PropTypes from 'prop-types';

const titleTable = [
    'id', 'name', 'groupCode', 'saleStartDate', 'saleEndDate', 'startDate', 'endDate',
    'numberOfBookingPeriod', 'bookingPeriod',
    'properties', 'remainVouchers', 'discountValue', 'maxDiscountValue',
    'minOrderValue', 'maxOrderValue', 'limitNumberOfSalesPerUser', 'originalPrice', 'order',
     'isAvailable', 'translations', 'voucherType'];
// const Model = {
//     id: PropTypes.string,
//     name: PropTypes.string,
//     email: PropTypes.string,
//     role: PropTypes.string,
//     password: PropTypes.string,
//     status: PropTypes.bool,
// };
export default {titleTable}
